/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Push_OffInputs */

const vi_notif_push_off = /** @type {(inputs: Notif_Push_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt đẩy`)
};

/**

* @param {Notif_Push_OffInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_push_off = /** @type {((inputs?: Notif_Push_OffInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Push_OffInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_push_off(inputs)
});